var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSparrowId = function SvgSparrowId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5c4.97 0 9 2.878 9 6.429 0 3.55-4.03 6.428-9 6.428-.316 0-.628-.011-.936-.034-.167-.013-.836.334-1.653.783l-1.826 1.008c-.975.53-1.822.955-2.014.89-.5-.168.583-4.18.31-4.362C1.108 11.468 0 9.791 0 7.93 0 4.379 4.03 1.5 9 1.5zm0 1.286c-4.335 0-7.714 2.413-7.714 5.143 0 1.346.817 2.656 2.305 3.642.36.239.51.539.581.872.03.136.04.265.04.403 0 .129-.01.27-.027.432l-.057.442-.215 1.295 2.478-1.36.465-.241c.577-.292.846-.388 1.203-.379l.1.006c.278.02.558.03.841.03 4.335 0 7.714-2.413 7.714-5.142 0-2.73-3.379-5.143-7.714-5.143zm-.595 1.849 5.757.952-4.135 4.117-.607-1.9c-.399.232-.811.507-1.236.825a17.792 17.792 0 0 0-2.54 2.302l-.432.477-.954-.862.43-.477a19.075 19.075 0 0 1 2.724-2.468c.55-.412 1.085-.761 1.607-1.046l-.614-1.92z",
    fillRule: "evenodd"
  })));
};

export default SvgSparrowId;